import "fslightbox"
import $ from "jquery"
import Cookies from "js-cookie"
import throttle from "lodash/throttle"
import lozad from "lozad"

import inject from "svg-inject"
import Swiper, { Navigation, Pagination, Autoplay, Controller, Lazy } from 'swiper';
import "../styles/style.scss"
import "../styles/new-pages.scss"
import * as forged from "./forged"
import "hint.css"
import * as forms from './forms'
import './about'
import './dynamicAdapt'
import { parseInt } from "lodash"
import './common/twinspark'
import './common/popup-banner'
import './common/header'

window.ga4SendSelectItemEvent = function ga4SendSelectItemEvent(productId) {
  if (__ga_ecommerce_items && productId) {
    let item = __ga_ecommerce_items.find(x => x.item_id == productId)
    if (item) {
      dataLayer.push({ ecommerce: null })
      dataLayer.push({
        event: "select_item",
        ecommerce: {
          items: [
            item
          ]
        }
      })
    }
  }
}

window.addEventListener("pageshow", function(event) {
  const historyTraversal = event.persisted || (typeof window.performance != "undefined" && window.performance.navigation.type === 2);
  const needToReload = location.pathname.startsWith("/diski/") || location.pathname.startsWith("/shiny/");
  if (historyTraversal && needToReload) {
    window.location.reload();
  }
});

window.addEventListener("load", () => {
  const svgList = document.querySelectorAll(".svg-img")
  svgList.forEach(el => inject(el))

  const observer = lozad()
  observer.observe()

  const shareButtonList = document.querySelectorAll(".share-button")
  if (shareButtonList) {
    shareButtonList.forEach(el => {
      el.addEventListener("click", e => {
        e.preventDefault()
        document.documentElement.classList.add("_hidden")
        document.getElementById("modal-share").classList.add("_visible")
      })
    })
  }

  const hideSiteLayout = () => {
    document.getElementById("site-layout").classList.add("d-none")
  }

  const showSiteLayout = () => {
    document.getElementById("site-layout").classList.remove("d-none")
  }

  document.getElementById("site-layout").onclick = e => {
    e.preventDefault()

    hideSiteLayout()
    document.documentElement.classList.remove("_hidden")

    const basket = document.getElementById("component_basket")
    if (basket) {
      basket.classList.remove("_visible")
    }

    const catalog = document.getElementById("component_catalog-filter")
    if (catalog) {
      catalog.classList.remove("_visible")
    }
  }

  if (document.getElementById("product-works-slider")) {
    new Swiper("#product-works-slider", {
      modules: [Navigation, Pagination, Autoplay, Controller, Lazy],
      spaceBetween: 15,
      slidesPerView: 1,
      navigation: {
        nextEl: ".page_product .slider-wrap .swiper-button-next",
        prevEl: ".page_product .slider-wrap .swiper-button-prev",
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
      },
    })
  }

  window.initFeedbackSliders = function() {
    document.querySelectorAll(".review-slider:not(.swiper-initialized)").forEach(el => {
      new Swiper(el, {
        modules: [Navigation, Pagination, Autoplay, Controller, Lazy],
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: el.querySelector(` .swiper-button-next`),
          prevEl: el.querySelector(` .swiper-button-prev`),
        },
      })
    })
  }
  initFeedbackSliders()


  if (document.getElementById("index-slider")) {
    new Swiper("#index-slider", {
      modules: [Navigation, Pagination, Autoplay, Controller, Lazy],
      autoplay: {
        delay: 3000,
        pauseOnMouseEnter: true,
      },
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: "#index-slider .swiper-pagination",
        clickable: true,
      },
    })
  }

  if (document.querySelectorAll(".product-slider").length) {
    new Swiper(".product-slider", {
      modules: [Navigation, Pagination, Autoplay, Controller, Lazy],
      spaceBetween: 15,
      slidesPerView: 1,
      pagination: {
        el: '.swiper__dots',
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        476: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        },
        1200: {
          slidesPerView: 5,
        },
      },
    })
  }

  if (document.querySelectorAll(".portfolio-slider").length) {
    new Swiper(".portfolio-slider", {
      modules: [Navigation, Pagination, Autoplay, Controller, Lazy],
      spaceBetween: 15,
      lazy: {
        loadPrevNext: true,
      },
      loop: true,
      watchOverflow: true,
      autoplay: {
        delay: 3000,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: '.swiper__dots',
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2
        },
        1200: {
          slidesPerView: 3,
        },
      },
    })

  }

  $(document.body).on("click", ".modal-close, .modal .shadow", e => {
    e.preventDefault()
    closeModal()
  })

  $(document.body).on("click", ".js-open-modal", e => {
    e.preventDefault()
    const id = e.currentTarget.getAttribute("data-modal-id")
    closeModal()

    if (document.getElementById(id)) {
      document.documentElement.classList.add("_hidden")
      document.getElementById(id).classList.add("_visible")
    }
    if (id == 'modal-call-order') {
      initImask()
    }
  })

  document.getElementById("modal-city-ask").querySelector(".my-city").onclick =
    () => closeModal()

  const accordeonList = document.querySelectorAll(
    ".component_accordeon._clickable"
  )
  accordeonList.forEach((el, index) => {
    el.onclick = e => {
      e.preventDefault()

      const item = accordeonList[index]

      if (!item.classList.contains("_active")) {
        accordeonList.forEach(i => i.classList.remove("_active"))
      }

      item.classList.toggle("_active")
    }
  })

  const cityList = document.querySelectorAll(".page_contacts .list .list-item")
  cityList.forEach((el, index) => {
    el.onclick = e => {
      e.preventDefault()

      const item = cityList[index]

      if (!item.classList.contains("_active")) {
        cityList.forEach(i => i.classList.remove("_active"))
      }

      item.classList.add("_active")
    }
  })

  $.ajaxSetup({
    beforeSend: function(xhr, settings) {
      function getCookie(name) {
        var cookieValue = null
        if (document.cookie && document.cookie != "") {
          var cookies = document.cookie.split(";")
          for (var i = 0; i < cookies.length; i++) {
            var cookie = $.trim(cookies[i])
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) == name + "=") {
              cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
              break
            }
          }
        }
        return cookieValue
      }
      if (!(/^http:.*/.test(settings.url) || /^https:.*/.test(settings.url))) {
        // Only send the token to relative URLs i.e. locally.
        xhr.setRequestHeader("X-CSRFToken", getCookie("csrftoken"))
      }
    },
  })

  $('.product-favorites-add:not([ts-action])').click(function(e) {
    e.preventDefault();

    let product_id = $(e.currentTarget)[0].dataset['product'];
    let model_name = $(e.currentTarget)[0].dataset['modelname'];
    let price = $(e.currentTarget)[0].dataset['price'];

    let fav_use = $(this).find('use');
    let fav_text = $(this).find('.fav-btn-text');

    $(this).toggleClass("_active")

    var added = $(this).hasClass('_active')
    fav_text.text(added ? 'Добавлено в избранное' : 'В избранное')
    fav_use.attr('xlink:href', added ? '#star2-fill' : '#star2')

    send_add_favorites_ajax(product_id, model_name, added, price);
  });

  function setMeta(name, val) {
    let el = document.querySelector(`meta[name="${name}"]`)
    if (el) {
      el.setAttribute("content", val)
    }
  }

  window.updateSeo = function(title, desc, keywords, url) {
    document.title = title
    setMeta('description', desc)
    setMeta('keywords', keywords)
    history.pushState({}, '', url)
  }

  const openSideFilter = function() {
    showSiteLayout();
    document.getElementById("component_catalog-filter").classList.add("_visible")
    document.documentElement.classList.add("_hidden")
  }

  const closeSideFilter = function() {
    hideSiteLayout();
    document.getElementById("component_catalog-filter").classList.remove("_visible")
    document.documentElement.classList.remove("_hidden")
  }

  let closeIcon = document.querySelector("#component_catalog-filter .title .close-icon")
  if (closeIcon) {
    closeIcon.onclick = e => {
      e.preventDefault()
      closeSideFilter()
    }
  }

  const tabHeaderList = document.querySelectorAll(".tabs-header .tab")
  const tabContentList = document.querySelectorAll(".tabs-content")

  if (tabHeaderList) {
    tabHeaderList.forEach((el, index) => {
      el.onclick = e => {
        e.preventDefault()

        tabHeaderList.forEach(el => el.classList.remove("_active"))

        el.classList.add("_active")

        tabContentList.forEach(el => el.classList.remove("_visible"))

        tabContentList[index].classList.add("_visible")
      }
    })
  }

  const catalogSizeList = document.querySelectorAll(
    ".page_catalog .filter-wrap .size-list .size"
  )
  if (catalogSizeList.length) {
    catalogSizeList.forEach(el => {
      el.onclick = e => {
        e.preventDefault()

        catalogSizeList.forEach(el => el.classList.remove("_active"))

        e.target.classList.add("_active")
      }
    })
  }

  window.setCatalogViewType = e => {
    if (e) e.preventDefault()
    let catalogViewType = document.querySelectorAll(
      ".page_catalog .filter-wrap .view-type-item"
    )
    catalogViewType.forEach(el => el.classList.remove("_active"))

    e.currentTarget.classList.add("_active")

    const type = e.currentTarget.getAttribute("data-type")

    Cookies.set("catalogViewType", type, { expires: 30 })

    const prodList = document.querySelectorAll(".component_product-item")
    const prodWrap = document.getElementById("catalog-prod-wrap")

    if (type === "list") {
      prodWrap.classList.add("_full")
      prodList.forEach(el => el.classList.add("_full"))
    } else if (type === "grid") {
      prodWrap.classList.remove("_full")
      prodList.forEach(el => el.classList.remove("_full"))
    }
  }

  const catalogViewType = document.querySelectorAll(
    ".page_catalog .filter-wrap .view-type-item"
  )
  if (catalogViewType.length) {
    catalogViewType.forEach((el) => {
      el.onclick = window.setCatalogViewType
    })
  }

  /**
   * Воспроизведение видео
   */
  const aboutPlayBtn = document.querySelector(".page_about .play-btn")
  if (aboutPlayBtn) {
    aboutPlayBtn.onclick = e => {
      e.preventDefault()

      const parent = aboutPlayBtn.parentNode

      aboutPlayBtn.classList.add("d-none")
      let iframe = parent.querySelector("iframe")
      iframe.classList.remove("d-none")
      iframe.style.height = e.currentTarget.parentNode.offsetHeight + "px"
      parent.querySelector("img").classList.add("d-none")
    }
  }

  const smoothScrollBtns = document.querySelectorAll(".scroll-to-top")
  if (smoothScrollBtns.length) {
    smoothScrollBtns.forEach(el => {
      el.onclick = e => {
        e.preventDefault()

        window.scrollTo({ top: 0, behavior: "smooth" })
      }
    })
  }

  const paymentItem = document.querySelectorAll(
    ".page_basket .contact-item .payment-item"
  )
  if (paymentItem.length) {
    paymentItem.forEach(el => {
      el.onclick = e => {
        e.preventDefault()

        paymentItem.forEach(i => i.classList.remove("_active"))

        el.classList.add("_active")
        let val = el.getAttribute("value")
        document.getElementById("payment_type").value = val
        let btn = el.closest("form").querySelector(".btn-order button")
        if (val === "on_delivery" || val == "installment") {
          btn.innerText = "Оформить заказ"
        } else {
          btn.innerText = "Оплатить заказ"
        }
      }
    })
  }

  const productMainImgWrap = document.getElementById("product-main-img-wrap")
  const productMainImg = document.getElementById("product-main-img")
  const productThumbImgList = document.querySelectorAll(
    ".page_product .product-data .image-wrap .thumb-imgs .nav-thumb"
  )
  if (productThumbImgList.length) {
    productThumbImgList.forEach((el, index) => {
      el.onclick = e => {
        e.preventDefault()

        productThumbImgList.forEach(i => i.classList.remove("_active"))

        el.classList.add("_active")

        const imgSrc = el.getAttribute("data-full-image")

        productMainImg?.setAttribute("src", imgSrc)

        productMainImgWrap.querySelectorAll("a").forEach((l, lIndex) => {
          if (lIndex === index) {
            l.classList.remove("d-none")
            l.classList.add("d-block")
          } else {
            l.classList.add("d-none")
            l.classList.remove("d-block")
          }
        })
      }
    })
  }


  async function initImageZoom() {
    let ImageZoom = await import(/* webpackChunkName: "js-image-zoom" */"js-image-zoom")
    const imageZoomOptions = {
      width: productMainImgWrap.clientWidth,
      height: productMainImgWrap.clientHeight,
      zoomPosition: "original",
    }

    if (
      !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      new ImageZoom(productMainImgWrap, imageZoomOptions)
    }
  }

  if (productMainImgWrap) {
    if (productMainImgWrap.classList.contains("_loop")) {
      initImageZoom()
    }
  }

  const changeArticleIframeSize = el => {
    const width = el.clientWidth
    const height = width * 0.5625

    el.style.height = `${height}px`
  }

  const changeNewsImageSize = el => {
    const width = el.clientWidth
    const height = width * 0.75

    el.style.height = `${height}px`
  }

  const changeReviewSliderImageSize = el => {
    if (window.innerWidth < 992) {
      const width = el.clientWidth
      const height = width * 0.75

      el.style.height = `${height}px`
    }
  }

  const reviewSliderList = document.querySelectorAll(".review-slider")
  if (reviewSliderList.length) {
    reviewSliderList.forEach(changeReviewSliderImageSize)
  }

  const articleIframeList = document.querySelectorAll(
    ".page_news-in article iframe"
  )
  if (articleIframeList) {
    articleIframeList.forEach(changeArticleIframeSize)
  }

  const newsList = document.querySelectorAll(".component_article img")
  if (newsList.length) {
    newsList.forEach(changeNewsImageSize)
  }

  async function initImask() {
    let IMask = await import(/* webpackChunkName: "imask" */"imask")
    const phoneMaskInputList = document.querySelectorAll(".phone-mask")
    phoneMaskInputList.forEach(el => {
      new IMask.InputMask(el, {
        mask: "+0 (000) 000-00-00",
      })
      el.addEventListener("focus", function(e) {
        var el = this
        setTimeout(function() {
          el.selectionStart = el.selectionEnd = 10000
        }, 0)
      })
    })
  }

  window.initImask = initImask

  if (document.querySelectorAll(".phone-mask")) {
    initImask()
  }

  const calcOffsetTop = () => {
    // if (window.location.pathname === "/calculator") {
    // 	return
    // }

    const header = document.getElementById("component_header")
    const body = document.body
    const bottom = header.querySelector(".bottom")
    const bottomHeight = bottom.offsetHeight

    let paddingTop = 0
    if (header.querySelector(".top").offsetHeight < window.scrollY) {
      bottom.classList.add("_sticky")

      paddingTop = `${bottomHeight}px`
    } else {
      bottom.classList.remove("_sticky")
    }

    body.style.paddingTop = paddingTop
  }
  calcOffsetTop()

  const calcMobileMenuTopOffset = () => {
    const header = document.getElementById("component_header")
    const mobileMenu = document.getElementById("mobile-menu")
    const bottom = header.querySelector(".bottom")

    if (bottom.classList.contains("_sticky")) {
      mobileMenu.style.top = `${bottom.clientHeight}px`
      mobileMenu.style.height = `calc(100% - ${bottom.clientHeight}px)`
    } else {
      mobileMenu.style.top = `${header.clientHeight}px`
      mobileMenu.style.height = `calc(100% - ${header.clientHeight}px)`
    }
  }
  calcMobileMenuTopOffset()

  window.onresize = throttle(() => {

    if (reviewSliderList.length) {
      changeReviewSliderImageSize()
    }

    if (newsList.length) {
      newsList.forEach(changeNewsImageSize)
    }

    if (articleIframeList) {
      articleIframeList.forEach(changeArticleIframeSize)
    }

    calcOffsetTop()
    calcMobileMenuTopOffset()
  }, 200)

  window.onscroll = throttle(() => {
    calcOffsetTop()
    calcMobileMenuTopOffset()
  }, 100)

  const basketFileWrap = document.getElementById("basket-file-wrap")
  if (basketFileWrap) {
    basketFileWrap.onchange = e => {
      const file = e.target.files[0]

      const formData = new FormData()
      formData.append("file", file)

      const spanList = document
        .getElementById("text-wrap")
        .querySelectorAll("span")

      spanList[0].classList.add("d-none")
      spanList[1].classList.remove("d-none")

      document.querySelector(".file-wrap").classList.remove("d-none")
      document.querySelector(".file-name").innerText = file.name
    }

    document.querySelector(".file-upload .file .remove").onclick = e => {
      e.preventDefault()

      const spanList = document
        .getElementById("text-wrap")
        .querySelectorAll("span")

      spanList[0].classList.remove("d-none")
      spanList[1].classList.add("d-none")

      document.querySelector(".file-wrap").classList.add("d-none")
    }
  }

  window.twinspark.func({
    dropdownsClose: function(o) {
      document.querySelectorAll(`[class*=dropdown_open]`).forEach(el => {
        if (el != o.el)
          el.classList.forEach(cls => {
            if (cls.endsWith("dropdown_open"))
              el.classList.remove(cls)
          })
      })
    },
    dropdownSelect: function(txt, val, o) {
      let el = o.el
      const dropdown = el.parentNode.parentNode 
      const children = dropdown.children
      const input = children[0]
      const button = children[1]
      const cls = dropdown.classList[0]
      dropdown.classList.remove(cls)
      input.value = val
      button.innerText = txt
      twinspark.trigger(o.el.closest("form"), "submit")
    },
    switcherChange: function(o) {
      let el = o.el
      let stepEl = el.parentElement.querySelector("[name=step]")
      let step = stepEl && parseInt(stepEl.value) || 1

      const countItem = el.parentNode.querySelector("input[name=quantity]")
      let count = Number(countItem.value)

      if (el.classList.contains("_plus")) {
        count += step
      } else if (el.classList.contains("_minus")) {
        count = count - step || 4
      }

      countItem.value = count
    },
    keepOnlyOneSelectedAndSubmit: function(o) {
      const container = o.el.closest("div")
      const all = container.querySelectorAll("input")
      const checked = container.querySelectorAll("input:checked")
      const form = o.el.closest("form")
      if (all.length == checked.length || checked.length == 0) {
        all.forEach(el => el.parentNode.remove())
      }
      twinspark.trigger(form, 'submit')
    },
    clearDependentCheckboxesAndSubmit: function(sel, o) {
      document.querySelectorAll(sel).forEach(el => el.checked = false)
      twinspark.trigger(o.el.closest('form'), 'submit')
    },
    filterCheckboxItems: function(o) {
      const val = o.el.value
      o.el.parentNode.querySelectorAll('.checkbox-items label').forEach(label => {
        const input = label.querySelector('input')
        if (input.disabled) return
        const el = label.querySelector('a')
        if (el.innerText.toLowerCase().indexOf(val.toLowerCase()) == -1) {
          label.classList.add('d-none')
          label.classList.remove('d-flex')
        } else {
          label.classList.add('d-flex')
          label.classList.remove('d-none')
        }
      })
    },
    resetFilters: function(o) {
      o.el.classList.add('btn_bg')
      const form = o.el.closest('form')
      form.reset()
      form.querySelectorAll('input[type=hidden], select').forEach(el => el.value = '')
      form.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false)
      twinspark.trigger(form, 'submit')
    },
    togglebox: function(o) {
      var parent = null
      if (o.el.type == 'label') {
        parent = o.el
      } else {
        parent = o.el.parentElement
      }
      var box = o.el.parentElement.querySelector('[type="checkbox"]');
      box.checked = !box.checked;
    },
    openSideFilter: function(o) {
      openSideFilter()
    },
    applyFastSeason: function(o) {
      const form = document.querySelector("#component_catalog-filter form")
      form.querySelectorAll("[name=seasons]").forEach(el => el.checked = false)
      if (o.el.value == "letnie") {
        form.querySelector("[name=seasons][value=letnie]").checked = true
      } else if (o.el.value) {
        form.querySelector("[name=seasons][value=zimnie]").checked = true
        form.querySelectorAll("[name=spikes]").forEach(el => el.checked = false)
        form.querySelector(`[name=spikes][value=${o.el.value}]`).checked = true
      }
      twinspark.trigger(form, "submit")
    },
    applyFastFilter: function(o) {
      var el = document.querySelector('#component_catalog-filter [name=' + o.el.name + ']')
      el.value = o.el.value
      twinspark.trigger(el.closest('form'), 'submit');
    },
    applySort: function(o) {
      window.applySort()
    },
    setCatalogViewType: function(o) {
      window.setCatalogViewType(o.event)
    },
    initNoUiSlider: function(o) {
      window.initNoUiSlider(document.querySelectorAll(".nouislider"))
    },
    scrollToTop: function(o) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    closeSideFilter: function(o) {
      closeSideFilter()
    },
    addFav: function(o) {
      window.addFav(o.event)
    },
    submit: function(o) {
      twinspark.trigger(o.el.closest('form'), 'submit');
      // window.submitFilter(o.el.closest('form'))
    },
  });

  $(document.body).on('click', '.vs_widget_button_svg', function() {
    document.querySelector('.vs_widget_submenu').classList.toggle('active');
    document.querySelector('.vs_widget_submenu').classList.toggle('vs_widget_hidden');
    document.querySelector('.vs_widget_button_svg').classList.toggle('active_vs_widget_button');
  });

  $(document.body).on('click', '.badge-wrap', e => e.preventDefault() && e.stopPropagation())

  // $(document.body).on('click', '#popup-banner-overlay, #popup-banner-close a', function() {
  //   document.getElementById('popup-banner-container').classList.remove('_visible')
  // });
})

window.addEventListener("load", function() {
  window.initNoUiSlider = async (noUiItems) => {
    let noUiSlider = await import(/* webpackChunkName: "nouislider" */"nouislider")
    let wNumb = await import(/* webpackChunkName: "wnumb" */"wnumb")
    wNumb = wNumb.default
    noUiItems.forEach(el => {
      if (el.noUiSlider) {
        el.noUiSlider.destroy()
      }

      if (el.classList.contains('noUi-target')) return

      const startVal = el.getAttribute("data-start-value")
      const endVal = el.getAttribute("data-end-value")
      const minVal = el.getAttribute("data-min-value")
      const maxVal = el.getAttribute("data-max-value")
      const decimals = el.getAttribute("data-decimals")

      let numFormat = wNumb({ decimals: parseInt(decimals) || 0 })

      const name = el.getAttribute("data-value-name")
      let left = document.getElementById(`${name}_gte`)
      let right = document.getElementById(`${name}_lte`)

      noUiSlider.create(el, {
        start: [+startVal, +endVal],
        connect: true,
        step: 0.5,
        range: {
          min: +minVal,
          max: +maxVal,
        },
      })

      let startValStr = decimals ? numFormat.to(+startVal) : Math.round(+startVal) + ""
      let endValStr = decimals ? numFormat.to(+endVal) : Math.round(+endVal) + ""
      const from = el.parentNode.querySelector(".from .value")
      const to = el.parentNode.querySelector(".to .value")
      const update_left = v => {
        from.value = decimals ? numFormat.to(+v) : Math.round(+v) + ""
        if (from.value != startValStr && left.value != from.value) {
          left.value = from.value
        }
      }
      const update_right = v => {
        to.value = decimals ? numFormat.to(+v) : Math.round(+v) + ""
        if (to.value != endValStr && right.value != to.value) {
          right.value = to.value
        }
      }
      const fireChange = () => {
        var event = new Event('changed');
        left.dispatchEvent(event);
        right.dispatchEvent(event);
      }

      from.addEventListener("change", () => {
        update_left(from.value)
        fireChange();
      })

      to.addEventListener("change", () => {
        update_right(to.value)
        fireChange();
      })

      el.noUiSlider.on("update", values => {
        update_left(values[0])
        update_right(values[1])
      })

      el.noUiSlider.on("change", (a, b) => {
        fireChange();
      })
    })
  }

  const noUiItems = document.querySelectorAll(".nouislider")
  if (noUiItems.length) {
    initNoUiSlider(noUiItems)
  }
})
